<div class="dialog">
  <div class="dialog-header">
    <div class="hp-content-title">{{'MY_RESERVATIONS'| translate}} ({{activeBookings?.length || 0}})</div>
    <span class="flex"></span>
    <div>
      <button class="dialog-close-btn" (click)="closeDialog()">
        <img src="./assets/img/times-circle.svg" width="30"></button>
    </div>
  </div>
  <div class="dialog-body">
    <div>
      <div class="row">
        <div class="column small-12 small-12 large-12">
          <div class="hp-content">
            <div class="row" *ngIf="!activeBookings.length">
              <div class="column small-12 small-12 large-12">
                {{ 'NO_BOOKINGS_AVAILABLE' | translate }}
              </div>
            </div>
            <div class="row">
              <div class="column small-12 small-12 large-12" *ngFor="let booking of activeBookings">
                <div class="hp-row">
                  <div>
                    <div class="hp-content-img-container">
                      <div class="inner"
                           [ngStyle]="{ backgroundImage: 'url('+ (taskInfo[booking.idActivity].photo | apiasset | defaultAsset:'DEFAULT_IMAGE_16_9' )+ ')' }"></div>
                    </div>
                    <div class="hp-content-hr"></div>
                    <div class="hp-content-txt-container">
                      <div class="hp-content-first-txt">{{ booking.room}}</div>
                      <div class="hp-content-second-txt">{{booking.label}}</div>
                      <div class="hp-content-fourth-txt ng-tns-c7-2 ng-star-inserted">
                        <div class="hp-hour-2">{{ booking.start | time }}
                          <span class="hp-duration-2">({{booking.duration}}')</span></div>
                        &mdash; <span class="hp-date-2">{{ booking.start | date }}</span>
                      </div>
                      <div class="hp-content-third-txt" *ngIf="booking?.employee">{{booking.employee}}</div>
                      <div class="hp-content-actions">
                        <button class="dialog-btn dialog-btn-color--danger" (click)="cancelBooking(booking)" *ngIf="booking.cancelable">
                          {{'CANCEL' | translate}}
                        </button>
                        <button class="dialog-btn dialog-btn-color--primary" (click)="confirmBooking(booking)" *ngIf="booking.inQueue && booking.queueOk">{{'5269' | translate}}<!--Confirm--></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
